import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  Form, Icon, Input, message, Tooltip
} from 'antd';
import ExtendedSelect from 'components/extendedSelect';
import { getKey, getLabel, getSelect } from 'library/helpers';
import { FormWrapper } from 'components/Page';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import settings from 'settings';
import _ from 'lodash';
import { list } from 'actions';
import REDUCER_KEY from 'reducers/reducer.keys';

const FormItem = Form.Item;

const mapStateToProps = state => ({
  rosters: state.api.rosters.data.results,
  inFlight: state.api.rosters.inFlight
});

const mapDispatchToProps = dispatch => ({
  loadRosters(searchText) {
    const page = 0;
    const pageSize = settings.APP_CONFIG.dropListSize;
    const sorted = [{
      id: 'name',
      desc: false
    }];
    const filters = [{
      id: 'active',
      value: true
    }];
    if (!_.isEmpty(searchText)) {
      filters.push({
        id: 'name__icontains',
        value: searchText
      });
    }
    return dispatch(list(
      REDUCER_KEY.rosters.key, {
        page,
        pageSize,
        filters,
        sorted
      }
    ));
  }
});

const mapPropsToFields = (props) => {
  const { dataSource } = props;
  const {
    roster, url
  } = dataSource;

  return {
    roster: Form.createFormField({ value: getSelect(roster) }),
    url: Form.createFormField({ value: url })
  };
};

const onFieldsChange = (props, fields) => {
  const { onFieldsChange: dispatchOnFieldsChange } = props;
  if (dispatchOnFieldsChange) {
    dispatchOnFieldsChange(fields);
  }
};

const onValuesChange = (props, values) => {
  const { onValuesChange: dispatchOnValuesChange } = props;
  if (dispatchOnValuesChange) {
    dispatchOnValuesChange(values);
  }
};

const FormInput = ({
  canAdmin, dataSource, inputFormItemLayout, inFlight, isEditMode, form, loadRosters, rosters
}) => {
  const { getFieldDecorator } = form;
  const {
    roster, url
  } = dataSource;
  const readonly = !canAdmin;
  return (
    <Form>
      <FormItem {...inputFormItemLayout.inputLayout} label="Roster">
        {getFieldDecorator('roster', {
          initialValue: roster,
          rules: [
            {
              required: true,
              message: 'Please select a roster.'
            }
          ]
        })(<ExtendedSelect
          fetching={inFlight}
          placeholder="Select Roster"
          disabled={isEditMode || readonly}
          dataSource={rosters}
          optionKey={getKey}
          optionLabel={getLabel}
          onSearch={loadRosters}
          onFocus={loadRosters}
        />)}
      </FormItem>
      <FormItem {...inputFormItemLayout.inputLayout} label="URL">
        {getFieldDecorator('url', {
          initialValue: 'Automatically generated'
        })(<Input
          addonAfter={(
            <Tooltip title="Copy" placement="right">
              <CopyToClipboard
                text={url}
                onCopy={() => {
                  message.success('Copied to clipboard');
                }}
              >
                <Icon type="copy" style={{ cursor: 'pointer' }} />
              </CopyToClipboard>
            </Tooltip>
          )}
          disabled
        />)}
      </FormItem>
    </Form>
  );
};

FormInput.propTypes = {
  canAdmin: PropTypes.bool,
  inFlight: PropTypes.bool,
  isEditMode: PropTypes.bool,
  rosters: PropTypes.array,
  dataSource: PropTypes.object,
  form: PropTypes.object,
  loadRosters: PropTypes.func,
  inputFormItemLayout: PropTypes.object,
  onFieldsChange: PropTypes.func,
  onValuesChange: PropTypes.func
};

FormInput.defaultProps = {
  canAdmin: false,
  inFlight: false,
  isEditMode: false,
  rosters: [],
  dataSource: {},
  form: {},
  inputFormItemLayout: {},
  loadRosters() {
  },
  onFieldsChange() {
  },
  onValuesChange() {
  }
};

const ConnectedFormInput = connect(mapStateToProps,
  mapDispatchToProps)(FormInput);

const ICalInput = FormWrapper(Form.create({
  mapPropsToFields,
  onFieldsChange,
  onValuesChange
})(ConnectedFormInput));

export default ICalInput;
